/* eslint-disable react/require-default-props */
import React, {ReactNode} from 'react';
import {View, ViewStyle} from 'react-native';

import {Shared} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import {styles} from './Popover.style';

interface PopoverProps {
  children: ReactNode;
  padded: boolean;
  style: {
    base: ViewStyle;
    content: ViewStyle;
  };
  accessible: boolean;
  accessibilityViewIsModal?: boolean;
}

const Popover = ({
  children = null,
  padded = false,
  style,
  accessibilityViewIsModal,
}: PopoverProps) => {
  const styleArray: ViewStyle[] = [styles.base];
  if (style?.base) {
    styleArray.push(style.base);
  }

  const contentStyleArray: ViewStyle[] = [styles.content];
  if (padded) {
    contentStyleArray.push(styles.contentPadded);
  }
  if (style?.content) {
    contentStyleArray.push(style.content);
  }

  return (
    <View
      {...testProperties(Shared.sharedPopover)}
      style={styleArray}
      testID={Shared.sharedPopover}
      accessibilityViewIsModal={accessibilityViewIsModal}>
      <View style={contentStyleArray}>{children}</View>
    </View>
  );
};

export default Popover;
